export function reportDailyHourRequest(filters) {
  return {
    type: '@reports/DAILY_HOUR/REQUEST',
    payload: { filters },
  };
}

export function reportDailyHourSuccess(data) {
  return {
    type: '@reports/DAILY_HOUR/SUCCESS',
    payload: { data },
  };
}

export function reportDailyHourFailure() {
  return {
    type: '@reports/DAILY_HOUR/FAILURE',
  };
}